export default __webpack_public_path__ + "couple-of-arrows-changing-places.png";